import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactImage from '../components/ContactImage';
import { fetchExtensionDetails } from '../reducers/extension';
import { logout } from '../reducers/user';
import styles from '../styles/form.scss';
import ListSelect from './ListSelect';
const ExtensionSelect = () => {
    const dispatch = useDispatch();
    const phones = useSelector((state) => state.contacts.phones);
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc);
    const availablePhones = phones
        .filter((p) => p.webRTCEnabled !== false)
        .filter((p) => !(p.readOnly === true))
        .map((p) => ({
        title: p.name,
        text: p.shortNumber,
        value: p.id,
        icon: (React.createElement(ContactImage, { email: p.email, id: p.id, type: p.type, status: false })),
    }));
    const hasPhones = availablePhones.length > 0;
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_small }, hasPhones
                        ? 'Select your extension'
                        : "It looks like you don't have any regular extensions that you can use."),
                    React.createElement("div", { className: styles.form_body }, hasPhones ? (React.createElement(ListSelect, { items: availablePhones, itemSelected: (value) => {
                            dispatch(fetchExtensionDetails(value));
                        } })) : (React.createElement("div", { className: styles.info_container },
                        React.createElement("p", { className: styles.text }, "Please either add a regular extension you have access to, or log in with a user that does have access to a regular extension."),
                        React.createElement("button", { className: styles.btn__primary, onClick: () => {
                                dispatch(logout());
                            } }, "Log out")))))))));
};
export default ExtensionSelect;
